module.exports = __webpack_public_path__ + "static/img/nongji.7cfc195e.png";